<div class="dashboard-header">
  <div class="dashboard-header__back-button" (click)="goBackToProjectsList()">
    <svg-icon src="/assets/img/arrow-sm-left.svg" />
  </div>

  <div class="dashboard-header__title">
    @if (project(); as projectData) {
      <div class="title-row">
        <b>{{ projectData.mainContactFullName }}</b> <span>{{ projectData.fullAddress }}</span>
      </div>
      <div class="title-row">
        <b>{{ projectData.name }}</b> <span>{{ projectData.projectId }}</span>
        <svg-icon
          class="cursor-pointer"
          src="/assets/img/ic-settings-black.svg"
          [permission]="{
            group: PermissionsGroups.PROJECTS,
            action: 'EDIT'
          }"
          [matMenuTriggerFor]="settingsMenu"
        />

        <mat-menu #settingsMenu="matMenu" xPosition="before" class="menu-v2">
          <button mat-menu-item (click)="edit()">
            <span>{{ 'Projects.PreviewHeader.edit' | translate }}</span>
          </button>
          @if (projectData.specification) {
            <button mat-menu-item (click)="downloadSpec()">
              <span>{{ 'Projects.PreviewHeader.downloadSpec' | translate }}</span>
            </button>
          }
          <button mat-menu-item (click)="remove()" class="hover_red red-500">
            <span>{{ 'Projects.PreviewHeader.remove' | translate }}</span>
          </button>
        </mat-menu>
      </div>
    } @else {
      <div class="title-row title-row--skeleton">
        <skeleton-item width="300px" height="19px" />
      </div>
      <div class="title-row title-row--skeleton">
        <skeleton-item width="180px" height="19px" />
      </div>
    }
  </div>

  <div class="dashboard-header__actions ml-auto">
    <project-dashboard-header-responsible
      [project]="project()"
      (projectUpdated)="projectUpdated.emit($event)"
    />

    <div class="relative">
      <button
        type="button"
        class="dashboard-header__action-button dashboard-header__action-button--tools"
        (click)="toggleToolsDropdown($event)"
      >
        <svg-icon src="/assets/img/ic-tools-icon.svg" />
        <span>{{ 'ProjectsDashboard.toolsDropdown' | translate }}</span>
        <svg-icon
          class="dashboard-header__action-arrow"
          [class.opened]="toolsDropdownOpen"
          src="/assets/img/ic-cheveron-down.svg"
        />
      </button>

      @if (toolsDropdownOpen) {
        <div class="dashboard-header__tools-dropdown menu-v2">
          @for (item of toolsMenuItems; track item.key) {
            <button
              type="button"
              class="dashboard-header__tools-dropdown-item"
              draggable="true"
              (dragstart)="onToolDragStart($event, item)"
              (dragend)="onToolDragEnd()"
              (click)="onToolSelected(item)"
            >
              <svg-icon [src]="item.icon || '/assets/img/dashboard-icon.svg'" draggable="false" />
              <span draggable="false">{{ item.label }}</span>
            </button>
          }
        </div>
      }
    </div>

    <button
      id="createMenu"
      type="button"
      class="dashboard-header__action-button dashboard-header__action-button--create"
      [matMenuTriggerFor]="createMenu"
      #menuTrigger="matMenuTrigger"
      [disabled]="stageChanging()"
    >
      <span>
        {{ 'ProjectsDashboard.statusDropdown' | translate }}:
        @if (projectStage()) {
          <b>{{ 'Projects.Stage.' + projectStage() | translate }}</b>
        }
      </span>
      <svg-icon
        class="dashboard-header__action-arrow"
        [class.opened]="menuTrigger.menuOpen"
        src="/assets/img/ic-cheveron-down.svg"
      />
    </button>

    <mat-menu #createMenu="matMenu" yPosition="above" class="mt-1 menu-v2">
      @for (key of projectStages; track key) {
        <button
          mat-menu-item
          (click)="onStageChange(ProjectStage[key])"
          [disabled]="projectStage() === ProjectStage[key] || stageChanging()"
          [ngClass]="{
            'hover_red red-500': ProjectStage[key] === ProjectStage.STAGE_LOST,
            'blue-500': projectStage() === ProjectStage[key]
          }"
        >
          <span>{{ 'Projects.Stage.' + ProjectStage[key] | translate }}</span>
        </button>
      }
    </mat-menu>
  </div>
</div>
